import { render, staticRenderFns } from "./ForgotPasswordNew.vue?vue&type=template&id=7196d748&scoped=true&"
import script from "./ForgotPasswordNew.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordNew.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordNew.vue?vue&type=style&index=0&id=7196d748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196d748",
  null
  
)

export default component.exports